const DB_NAME = 'SafeInvestorDB';
const STORE_NAME = 'InvestorForm';
const VERSION = 1;

const openDatabase = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);

    request.onerror = () => reject('Error opening database');
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
};

const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

const buildUserScopedKey = (userEmail: string, key: string): string => {
  return `${normalizeEmail(userEmail)}::${key}`;
};

export const saveToIndexedDB = async (userEmail: string, key: string, value: any): Promise<void> => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    const scopedKey = buildUserScopedKey(userEmail, key);
    const request = store.put(value, scopedKey);

    request.onsuccess = () => resolve();
    request.onerror = () => reject('Error saving data');
  });
};

export const getFromIndexedDB = async (userEmail: string, key: string): Promise<any> => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const scopedKey = buildUserScopedKey(userEmail, key);
    const request = store.get(scopedKey);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject('Error getting data');
  });
};

export const deleteFromIndexedDB = async (userEmail: string, key: string): Promise<void> => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    const scopedKey = buildUserScopedKey(userEmail, key);
    const request = store.delete(scopedKey);

    request.onsuccess = () => resolve();
    request.onerror = () => reject('Error deleting data');
  });
};

export const clearStore = async (): Promise<void> => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    store.clear();
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject('Failed to clear store');
  });
};




export const deleteOtherUsersData = async (currentUserEmail: string): Promise<void> => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const request = store.getAllKeys();

    request.onsuccess = () => {
      const keys = request.result as string[];
      const allowedKey = buildUserScopedKey(currentUserEmail, 'form');

      keys.forEach((key) => {
        if (typeof key === 'string' && key !== allowedKey) {
          store.delete(key);
        }
      });

      resolve();
    };

    request.onerror = () => reject('Error cleaning other users data');
  });
};
